<template lang="pug">
  router-view(
    class="unistar-container"
  )
</template>

<script>
export default {
  data () {
    return {

    }
  },
  components: {

  }
}
</script>

<style lang="stylus">
.unistar-container
  .el-dialog
    background #ffffff
    .el-dialog__body
      padding 24px
    .el-dialog__header
      padding: 16px 24px;
      border-bottom: 1px solid #d8d8d8;
      font-weight: 600;
      text-align: left;
  .section-divider
    width 100%
    border-top 0.5px solid #f0f0f0
    margin 24px 0
  // .el-table
  //   tr
  //     th
  //       background: #fafafa;
  //       color: #2c3031;
  //       font-weight: 500;
  .unistar-quotation-dialog
    .icon-shanchu1
      color: #3370d2;
      line-height: 29px;
      font-size:10px;
      cursor:pointer;
      margin-right: 8px
    .export-kol-report__btn
      display block
      margin-left auto
      margin-right 55px
    .el-table
      &:before
        content none
      tr
        th
          &:nth-child(1)
            padding-left 14px
        td
          &:nth-child(1)
            .cell
              padding-left 0
    .el-dialog__body
      padding 0px 25px 0px
      max-height 560px
      overflow auto
      .tab
        margin-bottom 10px
    .el-dialog__header
      text-align left
    .el-dialog__footer
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 32px;
      border-top: 1px solid #f0f0f0;
    .el-range-editor--mini.el-input__inner
      width 210px
    .table-footer
      display flex
      margin-top 10px
      justify-content space-between
      .el-button
        margin-left 24px
      .total_price
        .discount
          display flex
          justify-content flex-end
          align-items center
          span
            display inline-block
          div
            margin-left 50px
    .title
      font-size 16px
      color #2c3031
      font-weight 500
    .el-button--text
      font-weight normal
</style>
